import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

import { HeaderDetail } from '../models/header-detail';
import { ADPResourceService as ResourceService } from 'digital-core';
import { HeaderFactoryService } from './header-factory.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class adpAPIService {
  constructor(
    private resourceService: ResourceService,
    private httpsClient: HttpClient,
    private headerService: HeaderFactoryService,
    private configService: ConfigService
  ) {}

  post<T, Y>(urlKey: string, entity: T): Observable<Y> {
    let endpoint = urlKey;
    if (urlKey.toLowerCase().indexOf('url_') === 0) {
      endpoint = this.resourceService.getPortalSetting(urlKey).Value;
    }
    if(!endpoint.startsWith('http')) {
       endpoint = `${this.configService.apiUrl}/api/v1/${endpoint}`;
    }


    return this.httpsClient.post<Y>(
      endpoint,
      entity,
      this.headerService.getAuthorizationHeaderOptions()
    );
  }

  postWithCustomHeaders<T, Y>(urlKey: string, entity: T, customHeaders: HeaderDetail[]): Observable<Y> {
    let endpoint = urlKey;
    if (urlKey.toLowerCase().indexOf('url_') === 0) {
      endpoint = this.resourceService.getPortalSetting(urlKey).Value;
    }
    let headers = this.headerService.getAuthorizationHeaderOptions();

    customHeaders.forEach((customHeader) => {
      if (headers.headers.keys().includes(customHeader.headerId)) {
        headers.headers = headers.headers.delete(customHeader.headerId);
      }
      headers.headers = headers.headers.append(
        customHeader.headerId,
        customHeader.headerValue
      );
    });
    return this.httpsClient.post<Y>(`${this.configService.apiUrl}/api/v1/${endpoint}`, entity, { headers: headers.headers });
  }

  publicPost<T, Y>(urlKey: string, entity: T): Observable<Y> {
    const endpoint = this.resourceService.getPortalSetting(urlKey).Value;
    //const dotnetAPI = 'http://localhost:5000/api/v1.0';
    return this.httpsClient.post<Y>(
      `${this.configService.apiUrl}/api/v1/${endpoint}`,
   //   `${dotnetAPI}/${endpoint}`,
      entity,
      this.headerService.getPublicMulesoftHeaderOptions()
    );
  }

  get<Y>(urlKey: string, query: string): Observable<Y> {
    let endpoint = urlKey;
    if (urlKey.toLowerCase().indexOf('url_') === 0) {
      endpoint = this.resourceService.getPortalSetting(urlKey).Value;
    }
    if (query) {
      endpoint += query;
    }
    return this.httpsClient.get<Y>(
      `${this.configService.apiUrl}/api/v1/${endpoint}`,
      this.headerService.getAuthorizationHeaderOptions()
    );
  }

  getDocument<Y>(urlKey: string, query: string): Observable<Y> {
    let endpoint = urlKey;
    if (urlKey.toLowerCase().indexOf('url_') === 0) {
      endpoint = this.resourceService.getPortalSetting(urlKey).Value;
    }
    if (query) {
      endpoint += query;
    }
    // console.log('We are here');
    return this.httpsClient.get<Y>(
      //  `http://localhost:5000/api/v1.0/${endpoint}`,
      `${this.configService.apiUrl}/api/v1/${endpoint}`,
      this.headerService.getAuthorizationHeaderOptionsForDocumentDownload()
    ).pipe(catchError(this.parseErrorBlob));
  }

  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();
    const obs = Observable.create((observer: any) => {
      reader.onloadend = (e) => {
        var errorMessage = JSON.parse(reader.result as string);
        observer.error(
          new HttpErrorResponse({
            error: errorMessage,
            headers: err.headers,
            status: err.status,
            statusText: err.statusText,
            url: err.url,
          })
        );
        observer.complete();
      };
    });
    reader.readAsText(err.error);
    return obs;
  }
}
